import { ItemResultActionsRenderTargetComponent } from './targets/item-result-actions.render-target.component';
import { ItemResultImportantInfoRenderTargetComponent } from './targets/item-result-important-info.render-target.component';
import { ItemResultInfoRenderTargetComponent } from './targets/item-result-info.render-target.component';
import { ItemResultPriceRenderTargetComponent } from './targets/item-result-price.render-target.component';
import { ItemResultStockRenderTargetComponent } from './targets/item-result-stock.render-target.component';
import { ItemResultTitleRenderTargetComponent } from './targets/item-result-title.render-target.component';

export enum ItemResultRenderTarget {
  Title = 'title',
  Info = 'info',
  ImportantInfo = 'important-info',
  Stock = 'stock',
  Price = 'price',
  Actions = 'actions',
}

export const ItemResultRenderTargetComponents = {
  [ItemResultRenderTarget.Title]: ItemResultTitleRenderTargetComponent,
  [ItemResultRenderTarget.Info]: ItemResultInfoRenderTargetComponent,
  [ItemResultRenderTarget.ImportantInfo]: ItemResultImportantInfoRenderTargetComponent,
  [ItemResultRenderTarget.Stock]: ItemResultStockRenderTargetComponent,
  [ItemResultRenderTarget.Price]: ItemResultPriceRenderTargetComponent,
  [ItemResultRenderTarget.Actions]: ItemResultActionsRenderTargetComponent,
} as const;
